import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../lib/api';
import CampusUmbral from './CampusUmbral';
import CampusJardin from './CampusJardin';
import CampusContentView from './CampusContentView';
import CampusArchive from './CampusArchive';
import CampusDecretos from './CampusDecretos';
import CampusBitacora from './CampusBitacora';
import CamaraSagrada from './CamaraSagrada';
import NucleoGaia from './NucleoGaia';
import CampusDrawerView from './CampusDrawerView';
import CalendarioEnergetico from './CalendarioEnergetico';

const DRAWER_VIEWS = ['bienvenida', 'meditaciones', 'herramientas', 'recomendar', 'comunidad'];

const CampusApp = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const [passedUmbral, setPassedUmbral] = useState(false);
  const [currentView, setCurrentView] = useState('jardin'); // jardin, content, archive, decretos, bitacora
  const [viewParams, setViewParams] = useState(null);

  useEffect(() => {
    checkAccess();
  }, []);

  const checkAccess = async () => {
    try {
      const res = await api.get('/campus/status');
      if (res.data.has_access) {
        setHasAccess(true);
      } else {
        navigate('/campus-interioridad');
      }
    } catch {
      navigate('/login');
    } finally {
      setLoading(false);
    }
  };

  const handleUmbralComplete = () => {
    setPassedUmbral(true);
  };

  const handleNavigate = (view, params = null) => {
    setCurrentView(view);
    setViewParams(params);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#faf8f4] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#c9a227] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!hasAccess) return null;

  if (!passedUmbral) {
    return <CampusUmbral onComplete={handleUmbralComplete} />;
  }

  switch (currentView) {
    case 'content':
      return <CampusContentView contentId={viewParams?.contentId} monthKey={viewParams?.monthKey} onBack={() => handleNavigate('jardin')} />;
    case 'archive':
      return <CampusArchive onBack={() => handleNavigate('jardin')} onViewContent={(id) => handleNavigate('content', { contentId: id })} onViewMonth={(mk) => handleNavigate('archive-month', { monthKey: mk })} />;
    case 'archive-month':
      return <CampusArchive monthKey={viewParams?.monthKey} onBack={() => handleNavigate('archive')} onViewContent={(id) => handleNavigate('content', { contentId: id })} />;
    case 'decretos':
      return <CampusDecretos onBack={() => handleNavigate('jardin')} />;
    case 'bitacora':
      return <CampusBitacora onBack={() => handleNavigate('jardin')} />;
    case 'calendario':
      return <CalendarioEnergetico onBack={() => handleNavigate('jardin')} />;
    case 'camara':
      return <CamaraSagrada onBack={() => handleNavigate('jardin')} />;
    case 'nucleo':
      return <NucleoGaia onBack={() => handleNavigate('jardin')} />;
    default:
      if (DRAWER_VIEWS.includes(currentView)) {
        return <CampusDrawerView viewId={currentView} onBack={() => handleNavigate('jardin')} />;
      }
      return <CampusJardin onNavigate={handleNavigate} />;
  }
};

export default CampusApp;
